import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'

import { useTranslation } from '@common/hooks/translation';
import { useOutsideClick } from '@common/hooks/outsideClick';
import Config from '@app/dev/config/main';

export const Categories = ({
  selectCategory, categories = [], categoryId, setIsExpanded, isExpanded,
}) => {
  const t = useTranslation();

  const onChooseCategory = (id) => {
    selectCategory(id);
    Config.sportsbook.sportList?.closeAfterSelect && setIsExpanded(false);
  };

  const wrapperRef = useOutsideClick(() => isExpanded && setIsExpanded(false), [isExpanded]);
  const toggleExpanded = () => setIsExpanded(!isExpanded);

  const sortedCategorieList = useMemo(() => {
    const [selectedCategorieList, leftCategorieList] = _.partition(
      categories,
      (item) => item.id === categoryId,
    );

    return selectedCategorieList.concat(leftCategorieList);
  }, [categoryId, categories]);

  return (
    <div className={`categories-navigation  ${isExpanded ? 'active' : ''}`} ref={wrapperRef}>
      <div className="move-parent">
        <div className="move-container-inner">
          <div
            onClick={() => onChooseCategory('all')}
            className={`casino-section-categories ${
              categoryId === 'all' || categoryId === undefined ? 'active' : ''
            }`}
          >
            <div className="box-for-icon">
              <i className="global-icon icon-casino-categories-All" />
            </div>
            <p>{t('All games')}</p>
          </div>

          <div
            onClick={() => onChooseCategory('lastPlayed')}
            className={`casino-section-categories ${
              categoryId === 'lastPlayed' ? 'active' : ''
            }`}
          >
            <div className="box-for-icon">
              <i
                className="global-icon icon-casino-categories-LastPlayed"
              />
            </div>
            <p>{t('Last Played')}</p>
          </div>

          {sortedCategorieList.map((item) => (
            <div
              className={`casino-section-categories ${
                item.id === categoryId ? 'active' : ''
              }`}
              onClick={() => onChooseCategory(item.id)}
              key={item.id}
            >
              <div className="box-for-icon">
                <i className={`global-icon icon-casino-categories-${
                  (item.name === 'Fishing&Hunting'
                      && 'FishingHunting')
                    || (item.name === 'Drops&Winsslots'
                      && 'DropsWinsslots')
                    || (item.name === "Valentine'sDay" && 'ValentinesDay')
                    || (item.name === "St.Patrick'sDay" && 'StPatricksDay')
                    || item.name
                }`}
                />
              </div>
              <p className="box-for-left-item-text">{t(item.title)}</p>
              <span className="cont-for-item-casino">{item.games_count}</span>
            </div>
          ))}
        </div>
        {!!categories.length && (
          <div className="move-container-inner-button">
            <i
              onClick={toggleExpanded}
              className={`categories-list-toggle-icon global-icon ${
                isExpanded
                  ? 'icon-slim-arrow-left'
                  : 'icon-slim-arrow-right'
              }`}
            />
          </div>
        )}
      </div>
    </div>
  );
};

Categories.propTypes = {
  categories: PropTypes.array,
  categoryId: PropTypes.string,
  selectCategory: PropTypes.func,
  setIsExpanded: PropTypes.func,
  isExpanded: PropTypes.bool,
};
